<p-confirmDialog
  [appendTo]="'body'"
  header="Confirmation"
  icon="pi pi-exclamation-triangle"></p-confirmDialog>

<form [formGroup]="profileForm">
  <div class="panelhgt-adjest">
    <div class="gray-bg-rounded">
      <div class="user-hgt-left">
        <div [ngSwitch]="skeleton_flag">
          <div
            class="profile-box d-flex justify-content-left align-items-center mb-2"
            *ngSwitchCase="true">
            <div class="col-4">
              <img
                [src]="profileImage"
                alt="/assets/images/avatar-default.webp"
                onerror="this.onerror=null;this.src='/assets/images/avatar-default.webp';" />
            </div>
            <div class="col-8">
              <div class="d-flex justify-content-between">
                <div class="col-10">
                  <h1 class="mb-2">
                    <span *ngIf="!isEditingName" (click)="toggleNameEdit()">
                      {{ this.profileForm?.get("name")?.value }}
                      <i
                        class="pi pi-pencil ms-2 edit-pencil"
                        *ngIf="!this.profileForm.get('name')?.disabled"></i>
                    </span>
                    <input
                      *ngIf="isEditingName"
                      pInputText
                      [formControlName]="'name'"
                      (blur)="toggleNameEdit()"
                      (keyup.enter)="toggleNameEdit()"
                      #nameInput />
                  </h1>
                </div>
                <span class="col-auto"
                  ><span
                    class="toggle-hgt align-right text-right toggle-color-custom d-block"
                    [ngClass]="{
                      'cursor-not-allowed':
                        this.profileForm?.get('isProfileActive')?.disabled,
                    }">
                    <label class="col-12">
                      {{
                        this.profileForm?.get("isProfileActive")?.value === true
                          ? "Active"
                          : "In-Active"
                      }}
                    </label>
                    <p-toggleswitch
                      formControlName="isProfileActive"
                      (onChange)="
                        onProfileActiveToggleChanges($event)
                      " /> </span
                ></span>
              </div>
              <h2 class="mb-2">
                {{ this.profileForm?.get("loginEmail")?.value }}
              </h2>
              <h3 class="mb-2">
                {{ this.profileForm?.get("title")?.value }}
              </h3>
              <span
                class="d-flex justify-content-left align-items-center gap-5">
                <span
                  class="d-flex justify-content-between align-items-center gap-1">
                  <span><i class="pi pi-map-marker"></i></span>
                  <h4 class="mb-0 textwhite">
                    {{ this.profileForm?.get("locationName")?.value }}
                  </h4>
                </span>
              </span>
            </div>
          </div>
          <div
            class="profile-box d-flex justify-content-left align-items-center mb-2"
            *ngSwitchCase="false">
            <div class="col-4">
              <p-skeleton shape="circle" size="7rem" />
            </div>
            <div class="col-7">
              <h1 class="mb-2">
                <p-skeleton styleClass="mb-2" width="4rem" />
              </h1>
              <h2 class="mb-2">
                <p-skeleton styleClass="mb-2" width="6rem" />
              </h2>
              <h3 class="mb-2">
                <p-skeleton styleClass="mb-2" width="8rem" />
              </h3>
              <span>
                <p-skeleton styleClass="mb-2" width="10rem" />
              </span>
            </div>
          </div>
        </div>

        <div>
          <div class="">
            <div class="d-flex gap-3 align-items-center mb-3 mt-3 flex-wrap">
              <div
                class="d-flex align-items-center gap-1 text text-justify-uppercase"
                *ngFor="let item of roleType">
                <p-radiobutton
                  [inputId]="'userRoleId' + item.id"
                  (onClick)="onSelected($event)"
                  formControlName="userRoleId"
                  name="userRoleId"
                  [value]="item.id" />
                <label [for]="'userRoleId' + item.id" class="mt-1">{{
                  item?.name?.toLowerCase() === "power use"
                    ? "Power User"
                    : item.name
                }}</label>
              </div>
            </div>

            <div class="flex flex-col gap-2 mb-1">
              <label for="employeeId">Personnel Number</label>

              <p-select
                formControlName="employeeId"
                (change)="onPersonnelNumberChangeProfile($event)"
                [ngClass]="{ 'has-error': formErrors['employeeId'] }"
                (onBlur)="logValidationErrors()"
                [options]="unusedPersonnelNumber"
                optionLabel="personnelNumber"
                optionValue="id"
                appendTo="body"
                [showClear]="true"
                [filter]="true">
              </p-select>
            </div>

            <!-- <div class="d-flex gap-3 align-items-start">
              <div class="flex-grow-1">
                <div class="flex flex-col gap-2">
                  <label for="sendEmailAs">Send Email As</label>
                  <input
                    jniAutoCompleteBlocker
                    type="email"
                    pInputText
                    [ngClass]="{
                      'has-error':
                        profileForm.get('sendEmailAs')?.hasError('email') ||
                        profileForm.get('sendEmailAs')?.hasError('required'),
                    }"
                    formControlName="sendEmailAs"
                    (blur)="logValidationErrors()" />
                  <span class="error-msg" *ngIf="formErrors['sendEmailAs']">
                    {{ formErrors["sendEmailAs"] }}
                  </span>
                </div>
                </div>
              </div> -->
            <div class="d-flex gap-3 align-items-start">
              <div class="flex-grow-1">
                <div class="flex flex-col gap-2">
                  <label for="sendEmailAs">Send Email As</label>
                  <input
                    jniAutoCompleteBlocker
                    type="email"
                    pInputText
                    [ngClass]="{
                      'has-error':
                        profileForm.get('sendEmailAs')?.hasError('email') ||
                        profileForm.get('sendEmailAs')?.hasError('required'),
                    }"
                    formControlName="sendEmailAs"
                    (blur)="logValidationErrors()" />
                  <span class="error-msg" *ngIf="formErrors['sendEmailAs']">
                    {{ formErrors["sendEmailAs"] }}
                  </span>
                </div>
              </div>

              <div class="d-flex align-items-center gap-2 mt-4 pt-2">
                <label>Confirmed</label>
                <span class="toggle-hgt">
                  <p-toggleswitch
                    name="flexSwitchCheckDefaul3"
                    formControlName="isConfirmed"
                    (click)="clickDisabled($event)"
                    [ngClass]="{
                      'switch-color-override':
                        this.profileForm?.get('managerAccess')?.disabled &&
                        this.profileForm?.get('managerAccess')?.value,
                    }" />
                </span>
              </div>
            </div>
            <div class="d-flex justify-content-between mt-3">
              <div class="d-flex gap-1">
                <span class="col">BACM</span>
                <span class="col toggle-hgt"
                  ><p-toggleswitch
                    name="flexSwitchCheckDefaul3"
                    formControlName="managerAccess"
                    [ngClass]="{
                      'switch-color-override':
                        this.profileForm?.get('managerAccess')?.disabled &&
                        this.profileForm?.get('managerAccess')?.value,
                    }"
                /></span>

                <!-- <span class="col toggle-hgt"></span> -->
              </div>

              <div class="d-flex d-flex gap-1">
                <span class="col-auto">Support Manager</span>
                <span class="col toggle-hgt"
                  ><p-toggleswitch
                    formControlName="superManagerAccess"
                    [ngClass]="{
                      'switch-color-override':
                        this.profileForm?.get('superManagerAccess')?.disabled &&
                        this.profileForm?.get('superManagerAccess')?.value,
                    }" />
                </span>
                <!-- <span class="col toggle-hgt"></span> -->
              </div>

              <div class="d-flex d-flex gap-1">
                <span class="col">Inventory</span>
                <span class="col toggle-hgt"
                  ><p-toggleswitch
                    formControlName="inventoryAccess"
                    [ngClass]="{
                      'switch-color-override':
                        this.profileForm.get('inventoryAccess')?.disabled &&
                        this.profileForm.get('inventoryAccess')?.value,
                    }"
                /></span>

                <!-- <span class="col toggle-hgt"></span> -->
              </div>
            </div>

            <div
              class="d-flex mt-3 mb-2 gap-2 justify-content-between align-item-center">
              <div
                class="d-flex justify-content-between align-item-center gap-2">
                <span>Ledger</span>
                <span class="toggle-hgt">
                  <p-toggleswitch
                    id="flexSwitchCheckDefaultLedger"
                    name="flexSwitchCheckDefaultLedger"
                    formControlName="isLedgerActive"
                    [ngClass]="{
                      'switch-color-override':
                        this.profileForm?.get('isLedgerActive')?.disabled &&
                        this.profileForm?.get('isLedgerActive')?.value,
                    }"
                    (change)="onLedgerChange()"
                    [(ngModel)]="ledgerValue" />
                </span>
                <!-- <span>{{
              this.profileForm?.get("isLedgerActive")?.value
            }}</span> -->
              </div>
              <div
                class="d-flex justify-content-between align-item-center gap-2">
                <span class="col-auto">Executive Ledger Access</span>
                <span class="col-auto toggle-hgt"
                  ><p-toggleswitch
                    formControlName="executiveLedgerAccess"
                    [ngClass]="{
                      'switch-color-override':
                        this.profileForm?.get('executiveLedgerAccess')
                          ?.disabled &&
                        this.profileForm?.get('executiveLedgerAccess')?.value,
                    }"
                /></span>
              </div>
            </div>

            <h3 class="mb-2 mt-3" *ngIf="isLedgerEmailNotification">
              Email Notification
            </h3>
            <div class="row d-flex gap-2 mb-3">
              <div
                class="d-flex d-flex gap-3"
                *ngIf="isLedgerEmailNotification">
                <span class="col"></span>
                <span class="col align-item-center">IP</span>
                <span class="col align-item-center">CDI</span>
              </div>

              <div
                *ngIf="isLedgerEmailNotification"
                class="d-flex d-flex gap-3">
                <span class="col">Order BC</span>
                <span class="col toggle-hgt"
                  ><p-toggleswitch formControlName="isBcIpEmailEnabled" />{{
                    this.profileForm?.get("isBcIpEmailEnabled")?.value === true
                      ? "Yes"
                      : "No"
                  }}</span
                >
                <span class="col toggle-hgt"
                  ><p-toggleswitch formControlName="isBcCdiEmailEnabled" />
                  {{
                    this.profileForm?.get("isBcCdiEmailEnabled")?.value === true
                      ? "Yes"
                      : "No"
                  }}</span
                >
              </div>

              <div
                *ngIf="isLedgerEmailNotification"
                class="d-flex d-flex gap-3">
                <span class="col">Order BAC</span>
                <span class="col toggle-hgt"
                  ><p-toggleswitch formControlName="isBacIpEmailEnabled" />{{
                    this.profileForm?.get("isBacIpEmailEnabled")?.value === true
                      ? "Yes"
                      : "No"
                  }}</span
                >
                <span class="col toggle-hgt"
                  ><p-toggleswitch formControlName="isBacCdiEmailEnabled" />{{
                    this.profileForm?.get("isBacCdiEmailEnabled")?.value ===
                    true
                      ? "Yes"
                      : "No"
                  }}</span
                >
              </div>
            </div>

            <div class="divider-profile">
              <p-divider type="dotted" />
            </div>

            <div class="flex flex-col gap-2 mb-1">
              <label for="username"
                >Project
                <span *ngIf="isLedgerActive" class="madatory-field"
                  >*</span
                ></label
              >
              <p-select
                formControlName="projectId"
                [disabled]="!isLedgerActive"
                [ngClass]="{
                  'has-error': formErrors['projectId'] && isLedgerActive,
                }"
                (blur)="logValidationErrors()"
                [options]="unusedProjectList"
                optionLabel="projectName"
                optionValue="projectId"
                appendTo="body"
                [showClear]="true"
                [filter]="true">
              </p-select>
            </div>

            <div class="flex flex-col gap-2">
              <label for="primaryBACEmail">Primary BAC Email</label>
              <input
                pInputText
                formControlName="primaryBACEmail"
                jniAutoCompleteBlocker
                type="email"
                [disabled]="true" />
            </div>

            <div class="flex flex-col gap-2 mb-1">
              <label for="username"
                >Collector
                <span *ngIf="isLedgerActive && isBillCollMandatory"
                  >*</span
                ></label
              >
              <p-select
                formControlName="collectorId"
                [disabled]="!isLedgerActive"
                [ngClass]="{
                  'has-error': formErrors['collectorId'] && isLedgerActive,
                }"
                (blur)="logValidationErrors()"
                [options]="collectorList"
                optionLabel="name"
                optionValue="id"
                appendTo="body"
                [showClear]="true"
                [filter]="true">
              </p-select>
            </div>

            <div class="flex flex-col gap-2">
              <label for="username">Biller</label>
              <p-select
                formControlName="billerId"
                [disabled]="!isLedgerActive"
                [ngClass]="{
                  'has-error': formErrors['billerId'] && isLedgerActive,
                }"
                (blur)="logValidationErrors()"
                [options]="billerList"
                optionLabel="name"
                optionValue="id"
                appendTo="body"
                [showClear]="true"
                [filter]="true"></p-select>
            </div>
          </div>

          <div>
            <div class="row d-flex gap-1">
              <!-- <div class="d-flex mb-2 align-items-center justify-content-between">
            <span class="col-auto">Executive Ledger Access</span>
            <span class="col-auto toggle-hgt"
              ><p-toggleswitch
                formControlName="executiveLedgerAccess"
                [ngClass]="{
                  'switch-color-override':
                    this.profileForm?.get('executiveLedgerAccess')?.disabled &&
                    this.profileForm?.get('executiveLedgerAccess')?.value,
                }" />{{
                this.profileForm?.get("executiveLedgerAccess")?.value
              }}</span
            >
          </div> -->

              <div class="flex flex-col gap-2">
                <label for="displayEmailAs">Display Email</label>
                <input
                  jniAutoCompleteBlocker
                  type="email"
                  pInputText
                  [ngClass]="{
                    'has-error': profileForm
                      .get('displayEmailAs')
                      ?.hasError('email'),
                  }"
                  formControlName="displayEmailAs"
                  (blur)="logValidationErrors()" />
                <span class="error-msg" *ngIf="formErrors['displayEmailAs']">
                  {{ formErrors["displayEmailAs"] }}
                </span>
              </div>
              <div class="flex flex-col gap-2">
                <label for="displayPhoneNumber">Display Phone</label>
                <input
                  jniAutoCompleteBlocker
                  type="text"
                  pInputText
                  class="form-control"
                  id="dPhone"
                  name="dPhone"
                  formControlName="displayPhoneNumber" />
              </div>
              <div class="flex flex-col gap-2">
                <label for="displayPhoneNumber">Display Address</label>
                <textarea
                  rows="5"
                  jniAutoCompleteBlocker
                  formControlName="contactAddress"
                  pInputText></textarea>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</form>
